//#region src/integrations/github/githubTypes.ts
const GH_INTEGRATION_ID = "github-integration";

//#endregion
export { GH_INTEGRATION_ID };
//# sourceMappingURL=githubTypes.js.map